import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async action: a backend endpointot a type alapján választja
export const submitFinance = createAsyncThunk(
  'finance/submitFinance',
  async (data, thunkAPI) => {
    try {
      if (data.type === 'income') {
        const { data: res } = await axios.post(
          '/api/sales/create',
          data
        );
        return res;
      } else {
        const { data: res } = await axios.post(
          '/api/invoices/create',
          data
        );
        return res;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const financeSlice = createSlice({
  name: 'finance',
  initialState: {
    loading: false,
    error: null,
    success: false,
    transactions: [],
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
  builder
    // submitFinance kezelése
    .addCase(submitFinance.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    })
    .addCase(submitFinance.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.transactions.push(action.payload);
    })
    .addCase(submitFinance.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // fetchMonthlyFinance kezelése
    .addCase(fetchMonthlyFinance.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.summary = null;
    })
    .addCase(fetchMonthlyFinance.fulfilled, (state, action) => {
      state.loading = false;
      state.summary = action.payload;
    })
    .addCase(fetchMonthlyFinance.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
},

});

// Havi kimutatás lekérése
export const fetchMonthlyFinance = createAsyncThunk(
  'finance/fetchMonthlyFinance',
  async ({ year, month }, thunkAPI) => {
    try {
      const { data } = await axios.get(`/api/report/${year}/${month}`);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);



export default financeSlice.reducer;
export const { resetStatus } = financeSlice.actions;
